import { WifiOff, RefreshCw } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';

/**
 * Mid-session connection banner: credentials are intact but the session could
 * not be refreshed (offline / server hiccup). Retries automatically with
 * bounded backoff; the button forces an immediate retry.
 */
export default function ConnectionBanner() {
  const { connectionIssue, authStatus, retryConnection, user } = useAuth();
  if (!connectionIssue || authStatus !== 'ready' || !user) return null;
  return (
    <div
      role="status"
      data-testid="connection-issue-banner"
      className="fixed top-3 left-1/2 z-[2000] -translate-x-1/2 flex items-center gap-3 rounded-2xl bg-[#111114] px-4 py-2.5 text-white shadow-2xl"
    >
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-400/20 text-amber-300">
        <WifiOff size={16} />
      </span>
      <span className="leading-tight">
        <span className="block text-sm font-bold">Connection issue</span>
        <span className="block text-xs text-white/60">You&apos;re still signed in — reconnecting…</span>
      </span>
      <button
        type="button"
        onClick={retryConnection}
        data-testid="connection-issue-retry-btn"
        className="ml-1 inline-flex items-center gap-1 rounded-lg bg-white/10 px-2.5 py-1.5 text-xs font-bold transition-colors hover:bg-white/20"
      >
        <RefreshCw size={12} /> Retry now
      </button>
    </div>
  );
}
